/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspost_Media_Remove1Inputs */

const vi_cmspost_media_remove1 = /** @type {(inputs: Cmspost_Media_Remove1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bỏ ảnh`)
};

/**

* @param {Cmspost_Media_Remove1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_media_remove1 = /** @type {((inputs?: Cmspost_Media_Remove1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Media_Remove1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_media_remove1(inputs)
});
export { cmspost_media_remove1 as "cmsPost_media_remove" }